export default function Logo() {
    return (
        <img
            style={{ width: "100px", height: "100px" }}
            src='/logo192.png'
            alt="SHS badge"
        />
    );
}
